import {
    IconButton,
    PanelType,
    PrimaryButton,
} from "@fluentui/react";
import React, {useState} from "react";
import PanelGridComposer from "../GridComposer/PanelGridComposer";
import {GridSelectionMode, IColumnDetails} from "../../models/GridConfiguration";
import {IStorefrontSection} from "../../models/Storefront";
import {
    useCopyStorefrontSectionMutation,
    useGetStorefrontSectionTemplatesQuery
} from "../../store/endpoints/StorefrontSectionEndpoints";
import StorefrontSectionTemplateDeleteModal from "./StorefrontSectionTemplateDeleteModal";
import StorefrontSectionFloatingEditor from "./StorefrontSectionFloatingEditor";

interface IStorefrontSectionTemplateSelectorModalProps {
    isGlobal?: boolean;
    storefront: string;
    displayModal: boolean;
    closer: () => void;
}
const StorefrontSectionTemplateSelectorModal: React.FC<IStorefrontSectionTemplateSelectorModalProps> = props => {
    const [page, setPage] = useState<number>(1)
    const [pageSize, setPageSize] = useState<number>(25)
    const [filter, setFilter] = useState<string>()
    const [filterBy, setFilterBy] = useState<string>()
    const [sortBy, setSortBy] = useState<string>()
    const [sortDirection, setSortDirection] = useState<string>('desc')
    const templates = useGetStorefrontSectionTemplatesQuery({conditions: {page: page, pageSize: pageSize, sortBy: sortBy, sortDirection: (sortBy? sortDirection : undefined), searchBy: filterBy, searchTerm: filter}});
    const [applyTemplate] = useCopyStorefrontSectionMutation()
    const [selectedId, setSelectedId] = useState<string>();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const [processing, setProcessing] = useState<boolean>(false);
    
    const buttonColumns: IColumnDetails[] = [
        {
            index: 0,
            identifier: 'Apply',
            label: '',
            type: '',
            component:(ws: IStorefrontSection) => <PrimaryButton
                disabled={processing}
                onClick={() => {
                    setProcessing(true);
                    if(ws.id) {
                        applyTemplate({
                            request: {
                                existingId: ws.id,
                                storefront: props.storefront
                            }
                        }).unwrap().then(() => {
                            setProcessing(false);
                        })
                    }
                    props.closer()
                }
                }>{processing ? 'Applying' : 'Apply'}</PrimaryButton>,
            required: true,
        },
        {
            identifier: 'Delete',
            label: '',
            type: '',
            effectiveWidth: 50,
            component:(a: IStorefrontSection) => 
                <IconButton
                    aria-label="Delete"
                    iconProps={{iconName: 'Delete'}}
                    onClick={() => {{
                       setSelectedId(a.id)
                       setShowDeleteModal(true)
                    }}}
                >
                </IconButton>,
            required: true,
        },
        {
            identifier: 'Edit',
            label: '',
            type: '',
            effectiveWidth: 50,
            component:(a: IStorefrontSection) =>
                <IconButton
                    aria-label="Edit"
                    iconProps={{iconName: 'Edit'}}
                    onClick={() => {{
                        setSelectedId(a.id)
                        setShowEditModal(true)
                    }}}
                >
                </IconButton>,
            required: true,
        }
    ]
    return (
        <div>
            {selectedId && <StorefrontSectionFloatingEditor isGlobal={props.isGlobal} storefrontSectionId={selectedId} isOpen={showEditModal} closer={() => setShowEditModal(false)} />}
            <PanelGridComposer
                getItemId={(item: IStorefrontSection) => item.id ?? ''}
                page={page}
                pageSize={pageSize}
                sortBy={sortBy}
                sortDirection={sortDirection}
                overrideColumns={buttonColumns}
                canChangePageSize={true}
                onDismiss={props.closer}
                isOpen={props.displayModal}
                panelTitle={'Apply Storefront Section Template'}
                columnSetName={'StorefrontSection'}
                data={templates.data ?? {}}
                loading={templates.isFetching || templates.isLoading}
                onPageChange={setPage}
                onPageSizeChange={setPageSize}
                selectionMode={GridSelectionMode.none}
                onFilter={(filter, column) => {
                    setFilter(() => filter)
                    setFilterBy(() => column)
                }}
                onSort={(column, direction) => {
                    setSortBy(() => column)
                    setSortDirection(() => direction ?? 'desc')
                }}
                type={PanelType.smallFluid}
            />
            <StorefrontSectionTemplateDeleteModal
                selectedSectionTemplate={selectedId}
                displayModal={showDeleteModal}
                closer={async() => {
                    setShowDeleteModal(false);
                }}
            />
        </div>

    );
}
export default StorefrontSectionTemplateSelectorModal;